import type { Chapter } from '../types.ts';

export type SignatureMount = (container: HTMLElement, chapter: Chapter) => void;

type Loader = () => Promise<{ default: SignatureMount }>;

const REGISTRY: Record<string, Loader> = {
  'ch-01-the-bug-in-classical-physics': () => import('./ch-01-the-bug-in-classical-physics.ts'),
  'ch-02-the-reluctant-fix': () => import('./ch-02-the-reluctant-fix.ts'),
  'ch-03-einstein-makes-it-real': () => import('./ch-03-einstein-makes-it-real.ts'),
  'ch-04-matter-joins-the-party': () => import('./ch-04-matter-joins-the-party.ts'),
  'ch-05-wave-or-particle-yes': () => import('./ch-05-wave-or-particle-yes.ts'),
  'ch-06-the-cat-in-the-box': () => import('./ch-06-the-cat-in-the-box.ts'),
  'ch-07-the-spooky-part': () => import('./ch-07-the-spooky-part.ts'),
  'ch-08-computing-with-nature': () => import('./ch-08-computing-with-nature.ts'),
  'ch-09-willow': () => import('./ch-09-willow.ts'),
  'ch-10-the-obvious-question': () => import('./ch-10-the-obvious-question.ts'),
  'ch-11-the-so-what': () => import('./ch-11-the-so-what.ts'),
  'ch-12-close': () => import('./ch-12-close.ts'),
};

export async function loadSignature(name: string): Promise<SignatureMount | null> {
  const loader = REGISTRY[name];
  if (!loader) return null;
  try {
    const mod = await loader();
    return mod.default;
  } catch (err) {
    console.error(`failed to load signature ${name}`, err);
    return null;
  }
}
